(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vawagra-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.vwAnncReady === '1') return;
    root.dataset.vwAnncReady = '1';
    var msgs = Array.prototype.slice.call(root.querySelectorAll('[data-vw-annc-msg]'));
    if (msgs.length < 2) return;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 3000;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-in');
      msgs[i].classList.add('is-out');
      var prev = i;
      i = (i + 1) % msgs.length;
      msgs[i].classList.remove('is-out');
      msgs[i].classList.add('is-in');
      // clear the outgoing one once it has left, so it re-enters from below next lap
      setTimeout(function () { msgs[prev].classList.remove('is-out'); }, 520);
    }, interval);
  }
  function boot() { document.querySelectorAll('[data-vw-annc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vawagra-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.vwFaqReady === '1') return;
    root.dataset.vwFaqReady = '1';
    var v = root.querySelector('[data-vw-faq-video]');
    if (!v) return;

    // Play only while in view; pause off-screen so it never burns CPU/bandwidth idle.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.35 });
      io.observe(v);
    } else {
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }

    var btn = root.querySelector('[data-vw-faq-sound]');
    if (btn) {
      btn.addEventListener('click', function () {
        v.muted = !v.muted;
        root.classList.toggle('vw-faq--sound', !v.muted);
        if (!v.muted) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      });
    }
  }
  function boot() { document.querySelectorAll('[data-vw-faq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vawagra-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.vwHeroReady === '1') return;
    root.dataset.vwHeroReady = '1';

    var track = root.querySelector('[data-vw-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-vw-slide]'));
    var dotsWrap = root.querySelector('[data-vw-dots]');
    var prev = root.querySelector('[data-vw-prev]');
    var next = root.querySelector('[data-vw-next]');
    if (!track || !slides.length) return;

    var rtl = getComputedStyle(root).direction === 'rtl';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var index = 0, timer = null;

    var dots = [];
    if (dotsWrap) {
      dots = slides.map(function (_, i) {
        var b = document.createElement('button');
        b.className = 'vw-hero__dot-btn';
        b.type = 'button';
        b.setAttribute('aria-label', 'شريحة ' + (i + 1));
        b.addEventListener('click', function () { go(i); restart(); });
        dotsWrap.appendChild(b);
        return b;
      });
    }

    function apply() {
      var vp = root.querySelector('.vw-hero__viewport');
      var x = index * (vp ? vp.offsetWidth : 0);
      track.style.transform = 'translateX(' + (rtl ? x : -x) + 'px)';
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    function go(i) { index = (i + slides.length) % slides.length; apply(); }
    function start() { stop(); if (autoplay && slides.length > 1) timer = setInterval(function () { go(index + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function restart() { start(); }

    if (next) next.addEventListener('click', function () { go(index + 1); restart(); });
    if (prev) prev.addEventListener('click', function () { go(index - 1); restart(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    var sx = 0, sdx = 0, drag = false;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sdx = 0; drag = true; stop(); }, { passive: true });
    root.addEventListener('touchmove', function (e) { if (drag) sdx = e.touches[0].clientX - sx; }, { passive: true });
    root.addEventListener('touchend', function () {
      if (Math.abs(sdx) > 50) { var dir = sdx < 0 ? 1 : -1; go(index + (rtl ? dir : -dir)); }
      drag = false; restart();
    });

    window.addEventListener('resize', apply);
    apply();
    start();
  }

  function boot() { document.querySelectorAll('[data-vw-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // theme editor re-renders the section without a page load
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vawagra-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.vwReelsReady === '1') return;
    root.dataset.vwReelsReady = '1';

    var reels = Array.prototype.slice.call(root.querySelectorAll('[data-vw-reel]'));
    if (!reels.length) return;
    var dotsWrap = root.querySelector('[data-vw-reels-dots]');
    var prev = root.querySelector('[data-vw-reels-prev]');
    var next = root.querySelector('[data-vw-reels-next]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 3000;
    var n = reels.length;
    var index = 0, timer = null;

    var dots = [];
    if (dotsWrap) {
      dots = reels.map(function (_, i) {
        var b = document.createElement('button');
        b.className = 'vw-reels__dot';
        b.type = 'button';
        b.setAttribute('aria-label', 'ريل ' + (i + 1));
        b.addEventListener('click', function () { go(i); start(); });
        dotsWrap.appendChild(b);
        return b;
      });
    }

    function videos() { return reels.map(function (r) { return r.querySelector('video'); }); }
    function anyPlaying() { return videos().some(function (v) { return v && !v.paused; }); }

    // The entire layout: give each reel a slot, or none. No geometry involved.
    function render() {
      var p = (index - 1 + n) % n;
      var x = (index + 1) % n;
      reels.forEach(function (r, i) {
        r.classList.remove('is-prev', 'is-center', 'is-next');
        if (i === index) r.classList.add('is-center');
        // with 2 reels p === x, so only fill the next slot and leave prev empty
        else if (i === x) r.classList.add('is-next');
        else if (n > 2 && i === p) r.classList.add('is-prev');
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      // Buffer the centre reel the moment it lands centre — so a tap on play starts it
      // instantly instead of downloading from scratch. Side reels stay preload="metadata".
      var cv = reels[index].querySelector('video');
      if (cv && cv.dataset.vwBuffered !== '1') {
        cv.preload = 'auto';
        try { cv.load(); } catch (_) {}
        cv.dataset.vwBuffered = '1';
      }
    }

    function go(i) {
      var leaving = reels[index].querySelector('video');
      if (leaving && !leaving.paused) { leaving.pause(); reels[index].classList.remove('is-playing'); }
      index = (i + n) % n;
      render();
    }
    function start() { stop(); if (n > 1) timer = setInterval(function () { if (!anyPlaying()) go(index + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    if (next) next.addEventListener('click', function () { go(index + 1); start(); });
    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () { if (!anyPlaying()) start(); });

    // Drag/swipe via Pointer Events — one code path for mouse (desktop) and touch (mobile),
    // working alongside the arrows and the dots. A >40px move counts as a swipe; anything
    // smaller stays a plain click so the play button still works.
    var dragArea = root.querySelector('.vw-reels__wrap') || root;
    var sx = 0, sdx = 0, drag = false, pid = null;
    dragArea.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // Don't start a drag (and don't capture the pointer) when pressing a control —
      // otherwise the pointer capture swallows the arrows'/dots'/play button clicks.
      if (e.target.closest('button, a, [data-vw-reel-toggle], .vw-reels__arrow, .vw-reels__dot')) return;
      sx = e.clientX; sdx = 0; drag = true; pid = e.pointerId;
      dragArea.classList.add('is-dragging');
      if (dragArea.setPointerCapture) { try { dragArea.setPointerCapture(e.pointerId); } catch (_) {} }
      stop();
    });
    dragArea.addEventListener('pointermove', function (e) {
      if (drag && e.pointerId === pid) sdx = e.clientX - sx;
    });
    function endDrag(e) {
      if (!drag || (e && e.pointerId !== pid)) return;
      drag = false; pid = null;
      dragArea.classList.remove('is-dragging');
      // RTL: dragging right-to-left (negative dx) brings the next reel
      if (Math.abs(sdx) > 40) { go(index + (sdx < 0 ? 1 : -1)); start(); }
      else if (!anyPlaying()) start();
    }
    dragArea.addEventListener('pointerup', endDrag);
    dragArea.addEventListener('pointercancel', endDrag);

    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-vw-reel-toggle]');
      if (!btn || !root.contains(btn)) return;
      var reel = btn.closest('[data-vw-reel]');
      var video = reel.querySelector('video');
      if (!video) return;
      if (video.paused) {
        videos().forEach(function (v) { if (v && v !== video) v.pause(); });
        reels.forEach(function (r) { if (r !== reel) r.classList.remove('is-playing'); });
        var pr = video.play();
        if (pr && pr.catch) pr.catch(function () {});
        reel.classList.add('is-playing');
        stop(); // a playing reel owns the stage until it is paused
      } else {
        video.pause();
      }
    });
    // media events don't bubble — listen in the capture phase
    root.addEventListener('pause', function (e) {
      if (e.target.tagName !== 'VIDEO') return;
      var r = e.target.closest('[data-vw-reel]');
      if (r) r.classList.remove('is-playing');
      if (!anyPlaying()) start();
    }, true);

    render();
    start();
  }

  function boot() { document.querySelectorAll('[data-vw-reels]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
